module.exports = __webpack_public_path__ + "2a99cd3253efb9da6cd2cf36085549c6.webp";